module.exports = __webpack_public_path__ + "static/media/flute.28c351a5.jpg";